import { render, staticRenderFns } from "./TransportationGroup.vue?vue&type=template&id=46fb4626"
import script from "./TransportationGroup.vue?vue&type=script&lang=js"
export * from "./TransportationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports